import * as dataAccess from 'app/utils/ajax';
import { API_CONSTANTS } from 'app/constants/api-contants';
import { fetchData } from './comonsearch';

export const getSupportServicesList = async (param) => {
  const baseUrl = `${API_CONSTANTS.SUPPORT_DETAIL}/list`;
  let responseObj = await fetchData(baseUrl, param);
  return responseObj;
};
export const addSupportServices = async (incomingData) => {
  let payload = {
    data: {
      ...incomingData,
    },
  };

  let responseObj = await dataAccess.post(
    `${API_CONSTANTS.SUPPORT_DETAIL}/add`,
    payload
  );

  return responseObj;
};

export const deleteSupportServices = async (id) => {
  let url = `${API_CONSTANTS.SUPPORT_DETAIL}/delete?supportDetailId=${id}`;

  let responseObj = await dataAccess.del(url);
  return responseObj;
};

export const updateSupportServices = async (id, incomingData) => {
  let url = '';
  url = `${API_CONSTANTS.SUPPORT_DETAIL}/update?supportDetailId=${id}`;

  let payload = {
    data: {
      ...incomingData,
    },
  };

  let responseObj = await dataAccess.put(url, payload);
  return responseObj;
};

export const getSupportServicesById = async (id) => {
  let url = `${API_CONSTANTS.SUPPORT_DETAIL}/detail?supportDetailId=${id}`;
  let responseObj = await dataAccess.get(url);
  return responseObj;
};
